import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const InputSearchStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  flex-wrap: wrap;
  /* width: 450px; */
  width: 485px;

  /* Child element styles
  ------------------------------- */
  .input-wrapper {
    border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
    border: ${VARIABLES.BORDER_WIDTHS.MN} solid ${VARIABLES.COLORS.GRAY_2};
    background-color: white;
    height: 42px;
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};
    color: ${VARIABLES.COLORS.GRAY_3};
    padding: 8px 0;
    align-items: center;
    display: flex;
    width: 100%;

    .input {
      border: 0;
      flex: 1 1 auto;
      margin-right: 14px;
      width: 100%;

      ::-webkit-input-placeholder {
        color: ${VARIABLES.COLORS.GRAY_5};
      }

      :-ms-input-placeholder {
        color: ${VARIABLES.COLORS.GRAY_5};
      }

      ::placeholder {
        color: ${VARIABLES.COLORS.GRAY_5};
      }
    }

    .image-control {
      width: 48px;
      padding: 0 16px;
    }
  }

  .label {
    color: #1f2937;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .search-input-icon {
    cursor: default;
  }

  .search-input-icon.pointer:hover {
    cursor: pointer;
  }

  /* Modifiers
  ------------------------------- */
  &.theme-blue {
    .input {
      color: ${VARIABLES.COLORS.BLUE_1};
    }

    .label {
      color: #1f2937;
    }
  }

  /* State
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    /* width: 400px; */
    width: 455px;

    .input-wrapper {
      height: 40px;
      font-size: 16px;

      .image-control {
        width: 46px;
        padding: 0 15px;
      }
    }
  }

  @media all and (max-width: 1440.98px) {
    /* width: 360px; */
    width: 430px;

    .input-wrapper {
      height: 38px;
      font-size: 15px;

      .image-control {
        width: 44px;
        padding: 0 14px;
      }
    }
  }

  @media all and (max-width: 1366.98px) {
    /* width: 320px; */
    width: 400px;

    .input-wrapper {
      height: 36px;
      font-size: 14px;

      .image-control {
        width: 40px;
        padding: 0 13px;
      }
    }
  }

  @media all and (max-width: 1280.98px) {
    /* width: 280px; */
    width: 380px;

    .input-wrapper {
      height: 34px;
      font-size: 13px;

      .image-control {
        width: 38px;
        padding: 0 12px;
      }
    }
  }

  @media all and (max-width: 1024.98px) {
    /* width: 250px; */
    width: 100%;

    .input-wrapper {
      height: 32px;
      font-size: 12px;

      .image-control {
        width: 34px;
        padding: 0 10px;
      }
    }
  }
`
